import React from 'react';
import Grid from "@mui/material/Grid";
import MDTypography from "materialDashboard/components/MDTypography";
import {FormSectionBox} from "../../../components/FormSection";
import {useTranslation} from "react-i18next";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";


const Attachment = ({attachment, number, incidentRegistry, onDelete, onEdit, inputDisabled}) => {
    const {t} = useTranslation(['incidents']);

    const attachmentSourceRegistry = incidentRegistry.data?.attachmentSource ?? [];
    const attachmentSource = attachmentSourceRegistry.find((s) => s.code === attachment?.attachmentSource)?.description;

    const link = attachment?.webLink || attachment?.file?.path;

    return <FormSectionBox>
        <Grid container rowSpacing={2} columnSpacing={2} alignItems="center">
            <Grid item xs={8} md={5} sx={{display: "flex", alignItems: "center", gap: "8px"}}>
                <MDTypography fontWeight={"bold"} variant="h6" textTransform="capitalize">
                    {t('incidentForm.attachment.title')} {number}
                </MDTypography>
                <MDTypography variant="body2" color="secondary">
                    {attachment?.description ?? ""}
                </MDTypography>
                <Link href={link ?? ""} target="_blank"
                      component="button"
                      rel="noopener noreferrer"
                      disabled={!Boolean(link)}
                      onClick={(e) => {
                          window.open(link, "_blank");
                          e.preventDefault();
                      }} // Open link in new tab
                      sx={{display: 'flex', alignItems: 'center'}}>
                    <Icon>open_in_new</Icon>
                </Link>
            </Grid>
            <Grid item xs={4} md={3}>
                <MDTypography variant="body2" color="secondary">
                    {attachment?.file?.filename}
                    {attachment?.fileUpload?.name}
                    {attachment?.webLink}
                </MDTypography>
            </Grid>
            <Grid item xs={4} md={2}>
                <MDTypography variant="body2" color="secondary">
                    {attachmentSource}
                </MDTypography>
            </Grid>
            <Grid item xs={8} md={2} sx={{display: "flex", alignItems: "center", justifyContent: "end"}}>
                <Icon sx={{mr: 1.5}}>
                    {attachment?.visibility === "2" ? 'public' : 'lock'}
                </Icon>
                {
                    !inputDisabled && <IconButton onClick={() => onDelete(attachment)} color="error" size="medium">
                        <Icon>delete</Icon>
                    </IconButton>
                }
                {
                    !inputDisabled && <IconButton onClick={() => onEdit(attachment)} color="info">
                        <Icon>edit</Icon>
                    </IconButton>
                }
            </Grid>
        </Grid>
    </FormSectionBox>
}


export default Attachment;